module.exports = __webpack_public_path__ + "img/pair-web.609a526c.webp";